import { useNavigate } from 'react-router-dom'
import { Container, Box, Typography, Paper, Button, Alert } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'

export function ClaimFundInvalid({ status }) {
  const navigate = useNavigate()

  const getMessage = () => {
    switch (status) {
      case 'expired':
        return {
          title: 'Link Expired',
          message:
            'This fund claim link has expired. Please contact your financial advisor to request a new invitation.',
          alertType: 'warning',
        }
      case 'claimed':
        return {
          title: 'Already Claimed',
          message: 'This fund has already been claimed. If you believe this is an error, please contact support.',
          alertType: 'info',
        }
      case 'invalid':
      default:
        return {
          title: 'Invalid Link',
          message:
            'This fund claim link is invalid. Please check the link and try again, or contact your financial advisor.',
          alertType: 'error',
        }
    }
  }

  const { title, message, alertType } = getMessage()

  const getIconColor = () => {
    if (alertType === 'error') return 'error.main'
    if (alertType === 'warning') return 'warning.main'
    return 'info.main'
  }

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <ErrorOutlineIcon
            sx={{
              fontSize: 80,
              color: getIconColor(),
              mb: 2,
            }}
          />
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </Box>

        <Alert severity={alertType} sx={{ mb: 4 }}>
          {message}
        </Alert>

        <Typography variant="body1" sx={{ mb: 3, textAlign: 'center' }}>
          Need help? Contact us at <a href="mailto:support@givewise.ca">support@givewise.ca</a>
        </Typography>

        <Button variant="contained" color="primary" fullWidth onClick={() => navigate('/')}>
          Go to Home Page
        </Button>

        {status === 'claimed' && (
          <Box sx={{ mt: 2 }}>
            <Button variant="outlined" fullWidth onClick={() => navigate('/login')}>
              Sign In
            </Button>
          </Box>
        )}
      </Paper>
    </Container>
  )
}
